// utils/fcm.js
import { getToken } from "firebase/messaging";
import { messaging, onMessage } from "../firebase-config";

export const requestAndGetFCMToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: "BIx1cKbm_rujtsETxK65gtW1q7PYN3A9HFc-JZ-dCSMvuid1-J4n1MmaczLrcQ-YCdynAWIDQmT2dvxmfUKpzLQ",
            });
            return token;
        } else {
            console.warn("Notification permission denied.");
            return null;
        }
    } catch (err) {
        console.error("FCM token error:", err);
        return null;
    }
};

export const onMessageListener = () => {

    return onMessage(messaging, (payload) => {
        const { title, body, redirectUrl } = payload.notification;

        const notification = new Notification(title, {
            body,
            icon: "/logo192.png",
        });

        notification.onclick = () => {
            window.open(redirectUrl, '_blank');
        };
    });
};
